module.exports = __webpack_public_path__ + "static/media/sending.dcf5aa3b.gif";